import { render, staticRenderFns } from "./modalAlteracaoStatusAmostraCheckPoint.vue?vue&type=template&id=b60134a6&"
import script from "./modalAlteracaoStatusAmostraCheckPoint.vue?vue&type=script&lang=js&"
export * from "./modalAlteracaoStatusAmostraCheckPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports